import type { FunctionComponent } from 'react';
import { useEffect } from 'react';
import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';

import { getMarketingScreenInfo } from 'app/src/getMarketingScreenInfo';
import { PowerUpsList } from './PowerUpsList';
import type { Plugins } from './types';
import { useSharedStrings } from './useSharedStrings';

interface CategoryPageProps {
  readonly plugins: Plugins;
  readonly idCategory: string;
}

export const CategoryPage: FunctionComponent<CategoryPageProps> = ({
  plugins,
  idCategory,
}) => {
  const { getCategoryMessage } = useSharedStrings();
  const title = getCategoryMessage(idCategory);

  useEffect(() => {
    const { url, referrerUrl, referrerScreenName } = getMarketingScreenInfo();
    Analytics.sendMarketingScreenEvent({
      url,
      referrerUrl,
      referrerScreenName,
      event: {
        source: 'publicDirectoryCategoryScreen',
        name: 'publicDirectoryCategoryScreenV2',
        attributes: {
          category: idCategory,
          totalListed: plugins.length,
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!title) {
    return null;
  }

  return <PowerUpsList title={title} plugins={_.shuffle(plugins)} />;
};
